
import React from 'react';
import './PulseTag.css';

type PulseTagProps = {
  label: string;
};

export const PulseTag: React.FC<PulseTagProps> = ({ label }) => {
  return (
    <div className="pulse-tag">
      <span className="pulse-dot" />
      <span className="pulse-label">{label}</span>
    </div>
  );
};
